/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Grid } from '@mui/material';
import React from 'react'
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import ContentCard from '../../../../../components/ui-elements/cards/ContentCard';
import { FaUserCog, FaUsers } from 'react-icons/fa';
import { BsFillPeopleFill } from 'react-icons/bs';

const ManageUsersPage = () => {


    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Users'} />
                    </Grid>

                    <Grid item xs={12} sm={4} md={3}>
                        <ContentCard link="/manage-hashicorp" title="HashiCorp" subTitle="Manage HashiCorp" icon={<FaUserCog />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <ContentCard link="/manage-keycloak" title="Keycloak" subTitle="Manage Keycloak" icon={<FaUserCog />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <ContentCard link="/manage-admin-users" title="Admin" subTitle="Manage Admin Users" icon={<BsFillPeopleFill />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <ContentCard link="/manage-getchkd-users" title="GetChkd" subTitle="Manage GetChkd Users" icon={<BsFillPeopleFill />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <ContentCard link="/manage-mappings" title="Mapping" subTitle="Manage Mappings" icon={<BsFillPeopleFill />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <ContentCard link="/manage-asset-location" title="Asset Location" subTitle="Manage Asset Location Users" icon={<FaUserCog />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <ContentCard link="/manage-personnel" title="Personnel" subTitle="Manage Personnel Users" icon={<FaUserCog />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <ContentCard link="/manage-okta" title="Okta" subTitle="Manage Okta Users" icon={<FaUsers />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <ContentCard link="/manage-router" title="Router" subTitle="Manage Router Users" icon={<FaUsers />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <ContentCard link="/manage-splunk" title="Splunk" subTitle="Manage Splunk Users" icon={<FaUsers />}></ContentCard>
                    </Grid>
                </Grid>
            </Box>

        </>
    )

}

export default ManageUsersPage;
